import React, { useRef, useState, useEffect } from "react";
import styles from "./styles/InitialScreen.module.css";
import ChatInputBox from "./ChatInputBox";
import { LOGO_ONLY, LOGO_SQUARE } from "../constants";
import log from "cslog";
import { useSocket } from "./socket/SocketManager";
import DesignShowcase from "./DesignShowcase";
import { Link } from "react-router-dom";
import ExploreFeatures from "./ExploreFeatures";
import FeaturesBox from "./FeaturesBox";
import { URL as SOCKET_URL } from "./socket/socket";
import { useAtom } from "jotai";
import { agentAtom } from "./atoms";
import SocialMediaModal from "../social_media/SocialMediaModal";
import { Button, Input, Radio, Typography, theme } from "antd";

import ScrollingChatTips from "./ScrollingChatTips";

import {
    CalendarOutlined,
    CalendarFilled,
    WechatFilled,
    WechatWorkOutlined,
    ThunderboltFilled,
    RobotOutlined,
    RobotFilled,
    ThunderboltOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import RecentDesign from "./RecentDesign";
import SourcesInputBox from "./SourcesInputBox";
import ContentCalenderNew from "../content_calender_new/ContentCalenderNew";
import { getHeroIcon } from "../_helpers/heroicons";
import QurealLightCore from "../creations/QurealLightCore";
import { useMedia } from "react-use";
import { useRouteMatch } from "react-router-dom";
import { history } from "../_helpers/history";
import OneDay from "./OneDay";
import dayjs from "dayjs";
import CompleteProfileCard from "./CompleteProfileCard";
import { useFeatureFlag } from "../_helpers/featureFlags";

const { Title } = Typography;

function InitialScreen({ me, rs }) {
    let match = useRouteMatch("/home/:screen");

    const { sendMessage, isLoading } = useSocket();
    const chatInputRef = useRef(null);
    // const [agent, setAgent] = useState("master");
    const [agent, setAgent] = useAtom(agentAtom);
    const [screen, setScreen] = useState("spotlight");
    const isMobile = useMedia("(max-width: 700px)");

    const { token } = theme.useToken();

    const isSpotlightEnabled = useFeatureFlag("spotlight", true);
    const isAiChatEnabled = useFeatureFlag("ai_chat", false);
    const isGenFromSourceEnabled = useFeatureFlag("gen_from_source", true);
    // const isGenFromSourceEnabled = true;

    const handleSnippetClick = (text) => {
        // If you have a ref to your input component
        if (chatInputRef.current) {
            chatInputRef.current.setInputText(text);
        }
    };

    useEffect(() => {
        if (match?.params?.screen) {
            setScreen(match?.params?.screen);
        }
    }, [match?.params?.screen]);

    return (
        <div className={styles.wrapper}>
            {/* <Navbar /> */}
            {/* <p>Agent: {agent}</p> */}
            <div
                className={
                    screen === "ai_chat"
                        ? styles.ai_chat_layout
                        : styles.center_wrapper
                }
            >
                <div className={styles.centered_header}>
                    <div className={styles.header_wrapper}>
                        {/* <img
                            alt="Logo"
                            src={LOGO_SQUARE}
                            className={styles.logo_square}
                        /> */}
                        <Title
                            // className={styles.greeting_text}
                            level={isMobile ? 2 : 1}
                        >
                            {getCurrentGreeting()},{" "}
                            <span
                                style={{
                                    color: token.colorPrimary,
                                    fontStyle: "italic",
                                }}
                            >
                                {me?.first_name}
                            </span>
                        </Title>
                    </div>
                    {/* Match: {match && JSON.stringify(match)} */}
                    <div className={styles.subheader_wrapper}>
                        {getHeroIcon("sparkles", {
                            width: "24px",
                            color: token.colorWarning,
                        })}
                        <p>What would you like to create today?</p>
                    </div>

                    {me?.selected_org && (
                        <CompleteProfileCard organization={me.selected_org} />
                    )}

                    <div className={styles.screen_picker}>
                        {isSpotlightEnabled && (
                            <div
                                className={`${styles.screen_picker_item} ${
                                    screen === "spotlight" ? styles.active : ""
                                }`}
                                // onClick={() => setScreen("spotlight")}
                                onClick={() => history.push("/home/spotlight")}
                            >
                                <SearchOutlined
                                    className={styles.screen_icon}
                                />
                                {!isMobile && <span>Spotlight</span>}
                            </div>
                        )}
                        {isAiChatEnabled && (
                            <div
                                className={`${styles.screen_picker_item} ${
                                    screen === "ai_chat" ? styles.active : ""
                                }`}
                                // onClick={() => setScreen("ai_chat")}
                                onClick={() => history.push("/home/ai_chat")}
                            >
                                <RobotOutlined className={styles.screen_icon} />
                                {!isMobile && <span>AI Chat</span>}
                            </div>
                        )}
                        <div
                            className={`${styles.screen_picker_item} ${
                                screen === "content_calendar"
                                    ? styles.active
                                    : ""
                            }`}
                            // onClick={() => setScreen("content_calendar")}
                            onClick={() =>
                                history.push("/home/content_calendar")
                            }
                        >
                            <CalendarOutlined className={styles.screen_icon} />
                            {!isMobile && <span>Content Calendar</span>}
                        </div>
                        {isGenFromSourceEnabled && (
                            <div
                                className={`${styles.screen_picker_item} ${
                                    screen === "generate_from_source"
                                        ? styles.active
                                        : ""
                                }`}
                                // onClick={() => setScreen("generate_from_source")}
                                onClick={() =>
                                    history.push("/home/generate_from_source")
                                }
                            >
                                <ThunderboltOutlined
                                    className={styles.screen_icon}
                                />
                                {!isMobile && <span>Generate from source</span>}
                            </div>
                        )}
                    </div>
                </div>

                {screen === "spotlight" && !isMobile && isSpotlightEnabled && (
                    <div
                        style={{
                            width: isMobile ? "100%" : "620px",
                            maxWidth: "100%",
                            margin: "0 auto",
                            marginBottom: "80px",
                            // padding: isMobile ? "0 12px" : "0",
                            padding: "0",
                        }}
                    >
                        <SpotlightScreen me={me} isMobile={isMobile} />
                    </div>
                )}

                {screen === "ai_chat" && isAiChatEnabled && (
                    <>
                        <div className={styles.chat_input_area}>
                            <ChatInputBox
                                ref={chatInputRef}
                                onSubmit={(text) => {
                                    log.d(text, "User submitted");
                                    sendMessage(text, [], agent);
                                }}
                                show_suggestions={false}
                                wrapper_style={{ padding: "0 10px" }}
                                // disabled={
                                //     rs?.enable_chat ||
                                //         SOCKET_URL.startsWith("http://localhost")
                                //         ? false
                                //         : true
                                // }
                                disabled={false}
                                agent={agent}
                                setAgent={setAgent}
                            />
                        </div>
                    </>
                )}

                {((screen === "spotlight" && isSpotlightEnabled) ||
                    (screen === "ai_chat" && isAiChatEnabled)) && (
                    <>
                        <div className={styles.section_wrapper}>
                            <OneDay me={me} date={dayjs()} showHeader={true} />
                        </div>

                        <div style={{ maxWidth: "90vw" }}>
                            <ScrollingChatTips
                                onSnippetClick={handleSnippetClick}
                                agent={agent}
                                setAgent={setAgent}
                            />
                        </div>
                        <div className={styles.wrapper}>
                            {/* <FeaturesBox
                                me={me}
                                agent={agent}
                                setAgent={setAgent}
                            /> */}
                            <RecentDesign me={me} />
                        </div>
                    </>
                )}

                {screen === "generate_from_source" &&
                    isGenFromSourceEnabled && (
                        <SourcesInputBox me={me} isMobile={isMobile} />
                    )}

                {screen === "content_calendar" && (
                    <div className={styles.calendar_wrapper}>
                        <ContentCalenderNew
                            me={me}
                            wrapper_style={{
                                padding: "3px",
                                // position: "auto",
                            }}
                        />
                    </div>
                )}
            </div>

            {/* <ExploreFeatures me={me} /> */}
        </div>
    );
}

export default InitialScreen;

function getCurrentGreeting() {
    const time = new Date().getHours();
    if (time < 12) {
        return "Good Morning";
    } else if (time < 18) {
        return "Good Afternoon";
    } else {
        return "Good Evening";
    }
}

function Navbar() {
    return (
        <div className={styles.navbar}>
            <Link to="/creatives/all">All Creations</Link>
            <Link to="/creatives/content-calendar">Content Calendar</Link>
            <Link to="/settings/brands">Settings</Link>
        </div>
    );
}

// function ScrollingChatTips({ onSnippetClick, agent, setAgent }) {
//     const examples = [
//         { key: "linkedin", value: "Create a linkedin post " },
//         { key: "graphics_designer", value: "Generate a design on" },
//         { key: "blogger", value: "Write a blog on" },
//         { key: "facebook", value: "Create a Facebook post on" },
//         { key: "instagram", value: "Make a instagram Story featuring " },
//         { key: "file_master", value: "Make this file" },
//         { key: "twitter", value: "Write a tweet" },
//     ];

//     // Find the matching example
//     const normalizedAgent = agent?.toLowerCase().trim();
//     const matchedExample = examples.find(
//         (example) => example.key.toLowerCase() === normalizedAgent
//     );

//     // Auto-fill chat input when agent changes
//     useEffect(() => {
//         if (matchedExample) {
//             onSnippetClick(matchedExample.value);
//         }
//     }, [normalizedAgent]); // re-run only if `agent` changes

//     return (
//         <div className={styles.example_snippets_container}>
//             {examples.map((example, index) => (
//                 <div
//                     key={index}
//                     className={styles.example_snippet}
//                     onClick={() => {
//                         onSnippetClick(example.value);
//                         setAgent(example.key); // <-- Update agent when example is clicked
//                     }}
//                 >
//                     {example.value}
//                 </div>
//             ))}
//         </div>
//     );
// }

// const { Text } = Typography;

function SpotlightScreen({ isMobile, me }) {
    const [selected_item, setSelectedItem] = useState(null);
    const [open_preview, setOpenPreview] = useState(false);

    const inputRef = useRef(null);

    return (
        <div
            style={{
                marginTop: "20px",
                // width: "100%",
                // boxSizing: "border-box",
                // padding: "12px",
            }}
        >
            {/* <Input
                style={{
                    border: "1px solid #cccc",
                }}
                suffix={<SearchOutlined />}
            /> */}
            <QurealLightCore
                open={true}
                setOpen={() => {}}
                isMobile={isMobile}
                me={me}
                selected_item={selected_item}
                setSelectedItem={setSelectedItem}
                open_preview={open_preview}
                setOpenPreview={setOpenPreview}
                inputRef={inputRef}
                is_spot={false}
            />
        </div>
    );
}
